import { defineComponent as _defineComponent } from 'vue'
import { API } from '@/services/api/api'
import { showErrorToast, showSuccessToast } from '@/utils/common'
import Vue, { ref, computed, getCurrentInstance, onMounted } from 'vue'
import { useI18n } from '@/utils/i18n/useI18n'
import { FISCAL_TYPES } from '@/common/constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenDrawerButton',
  setup(__props) {

const { t } = useI18n()
const app = getCurrentInstance()
const store = app.proxy.$store

const buttonDisabled = ref(false)

const fiscalType = computed(() => store.state.auth.localization.fiscal_type)

const openDrawer = async () => {
  const { error } = await API.openDrawer()
  if (!error) {
    showSuccessToast(Vue.toasted, t('message.settings.openingDrawer'))
    buttonDisabled.value = true
    setTimeout(() => {
      buttonDisabled.value = false
    }, 5000)
  } else {
    showErrorToast(Vue.toasted, error)
  }
}

onMounted(() => {
  buttonDisabled.value = fiscalType.value !== FISCAL_TYPES.K2
})

return { __sfc: true,t, app, store, buttonDisabled, fiscalType, openDrawer }
}

})